import React, { useState, useEffect } from 'react';
import { Modal, Box, CircularProgress } from '@mui/material';
import { getSchemaForPlace, getLightsState, updateLightsState, openTheDoor } from '../api.js';

import SwitchSchema from './SwitchSchema/SwitchShema';

const PlaceManagerModal = ({ open, onClose, place_id, token, notificationState }) => {
  const [schemaPath, setSchemaPath] = useState('');
  const [loading, setLoading] = useState(false);
  const [lights, setLights] = useState(null);

  const [lightsStateLoaded, setLightsStateLoaded] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const schemaData = await getSchemaForPlace(place_id, token, notificationState);
        setSchemaPath(schemaData);

        const lightsData = await getLightsState(place_id, token, notificationState);
        if (lightsData) {
          const invertedLightsData = {};
          Object.keys(lightsData).forEach((key) => {
            // Приходится инвертировать статус включения света из-за логики работы реле
            invertedLightsData[key] = !lightsData[key] ? 1 : 0;
          });
          setLights(invertedLightsData);
        }

        setLightsStateLoaded(true);
      } catch (error) {
        console.error('Failed to fetch data:', error);
      } finally {
        setLoading(false);
      }
    };

    if (open) {
      fetchData();
    }
  }, [open, lightsStateLoaded]);

  const handleLightChange = (table) => async (event) => {
    const updatedLights = {
      ...lights,
      [table]: event.target.checked ? 1 : 0,
    };

    setLights(updatedLights);

    const setLight = {
      [table]: event.target.checked ? 0 : 1,
    };

    try {
      setIsUpdating(true);
      // Отправляем запрос на сервер для обновления состояния света
      await updateLightsState(place_id, token, notificationState, setLight);
    } catch (error) {
      console.error('Failed to update lights state:', error);
      // Если запрос не удался, откатываем состояние
      setLights((prevLights) => ({
        ...prevLights,
        // Приходится инвертировать статус включения света из-за логики работы реле
        [table]: event.target.checked ? 0 : 1,
      }));
    } finally {
      setIsUpdating(false); // Включаем переключатели обратно после завершения запроса
    }
  };

  const handleDoorOpen = async () => {
    try {
      setIsUpdating(true);
      await openTheDoor(notificationState, token, place_id);
    } catch (error) {
      console.error('Failed to opern the door: ', error);
    } finally {
      setIsUpdating(false); // Включаем переключатели обратно после завершения запроса
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      maxWidth='xs'
      fullWidth
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          maxWidth: '90%',
        }}
      >
        {loading || !schemaPath ? (
          <CircularProgress /> // Отображаем лоадер во время загрузки
        ) : (
          <Box
            sx={{
              position: 'relative',
              width: '100%',
              height: '100%',
              border: 'solid',
              maxHeight: 'calc(100svh)',
            }}
          >
            <img
              src={schemaPath}
              alt='Схема зала'
              style={{
                width: '100%',
                height: 'auto',
                display: 'block',
                maxHeight: '90svh',
              }}
            />
            <SwitchSchema
              place_id={place_id}
              lights={lights}
              handleLightChange={handleLightChange}
              handleDoorOpen={handleDoorOpen}
              lightsStateLoaded={lightsStateLoaded}
              isUpdating={isUpdating}
            />
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default PlaceManagerModal;
